import {isValidEmail} from "./emailValidation";

export type BillingInfo = {
  email?: string;
  name?: string;
  company?: string;
  street?: string;
  zip?: string | number;
  city?: string;
}

export interface ProjectWithBilling {
  billing?: BillingInfo | null;
}

export const isBillingValid = (project: ProjectWithBilling): boolean => {
  return !project.billing || (
    !!project.billing.email &&
    isValidEmail(project.billing.email) &&
    !!project.billing.name &&
    !!project.billing.company &&
    !!project.billing.street &&
    !!project.billing.zip &&
    !!project.billing.city
  );
}

